import React from "react";
import { LoanCohortsTopbar } from "./LoanCohortsTopbar";
import { CohortFilters } from "./CohortFilters";
import { CumulativeDefaultCurves } from "./CumulativeDefaultCurves";
import { CohortMatrix } from "./CohortMatrix";
import { CohortInsights } from "./CohortInsights";

interface LoanCohortsProps {
  onSidebarToggle: () => void;
}

export const LoanCohorts: React.FC<LoanCohortsProps> = ({
  onSidebarToggle,
}) => {
  return (
    <div className="p-6 pb-8 flex flex-col gap-6">
      <LoanCohortsTopbar onSidebarToggle={onSidebarToggle} />

      {/* FILTERS + CURVES */}
      <section className="grid grid-cols-[1.2fr_2.5fr] gap-3.5 items-stretch xl:grid-cols-1">
        <CohortFilters />
        <CumulativeDefaultCurves />
      </section>

      {/* BOTTOM: MATRIX + SUMMARY */}
      <section className="grid grid-cols-[2.4fr_1.6fr] gap-3.5 mt-1.5 xl:grid-cols-1">
        <CohortMatrix />
        <CohortInsights />
      </section>
    </div>
  );
};
